import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react"; // import classnames from "classnames";
// components

import withUserMenu from "../../UserMenu.store"; // components

import Package from "../../../Package";
import styles from "./RecentlyViewed.module.scss";
export var RecentlyViewedComponent = function RecentlyViewedComponent(a) {
  var b = a.userMenu,
      c = a.onPackageClick,
      d = _slicedToArray(b, 1),
      e = d[0],
      f = e.recentlyViewed || [];

  return /*#__PURE__*/React.createElement("div", {
    className: "ta-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, f.length ? /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, f.map(function (a) {
    return /*#__PURE__*/React.createElement(Package, {
      key: a.slug,
      data: a,
      onClick: c,
      className: styles.package,
      summary: !0
    });
  })) : /*#__PURE__*/React.createElement("p", {
    className: styles.paragraph
  }, "The properties you view will appear here.")));
};
export var RecentlyViewed = withUserMenu(RecentlyViewedComponent);
export default RecentlyViewed;